import api from "../../apis/siar";

//Querie para obtener las alertas tempranas
export const fetchUltimasAlertasAction = () => async (dispatch, getState) => {
  let q = `query{
    listaAlertasCapInfo{
              total
              registros{
                  id
                  event
                  severity
                  expires
                  description
                  instruction
                  contact
                  area{
                      areaDesc
                  }
                  alert{
                    identifier
                    sent
                  }
                  resource{
                      uri
                  }
                  
              }
          }
      }`;
  const promise = await api.post("/", {
    query: q,
  });

  dispatch({
    type: "FETCH_LAST_ALERTS",
    payload: promise.data.data.listaAlertasCapInfo,
  });
};

//Acción para obtneer las alertas tempranas
export const clearUltimasAlertasAction = function () {
  return {
    type: "CLEAR_LAST_ALERTS",
  };
};
